var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.2,419c-60,0-108.7-48.7-108.6-108.7c0-46.1,29.1-87.2,72.6-102.5c-0.1-2-0.2-4.1-0.2-6.1 C81,135,135,81,201.7,81c43.2,0,83.1,23.1,104.6,60.5c33.2-22.2,78.2-13.3,100.4,19.9c8,11.9,12.2,25.9,12.2,40.3 c0,8.9-1.6,17.8-4.8,26.1c52.3,10.6,86,61.6,75.4,113.9c-9.2,45-48.7,77.3-94.7,77.3H117.2z M176.8,255.3c-7.1,7.1-7.1,18.5,0,25.6 c7.1,7.1,18.5,7.1,25.6,0l29.4-29.4v101.2c0.2,10,8.5,17.9,18.5,17.7c9.7-0.2,17.5-8,17.7-17.7V251.4l29.4,29.4 c6.9,7.2,18.3,7.5,25.6,0.7c7.2-6.9,7.5-18.3,0.7-25.6c-0.2-0.2-0.4-0.5-0.7-0.7l-60.4-60.4c-7-7.1-18.4-7.1-25.5-0.1 c0,0-0.1,0.1-0.1,0.1l-60.4,60.4H176.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bdf3847496c5fa04f675bef8a35d34f1.svg";
export { ForwardRef as ReactComponent };